module.exports = __webpack_public_path__ + "img/663.abb9414a.jpg";